/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Help1Inputs */

const en_navtitles_help1 = /** @type {(inputs: Navtitles_Help1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {Navtitles_Help1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_help1 = /** @type {((inputs?: Navtitles_Help1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Help1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_help1(inputs)
});
export { navtitles_help1 as "navTitles_help" }